// Actions and information with no name and nothing connected to them: what's left when a node is added to the canvas
// and the model is saved before it is named or joined to anything. Saved, it shows in the analysis as a step or output
// of its own that leads nowhere, so saving asks about them first. Pure, so it can be tested without a page
import { LinqsetEdge, LinqsetNode, NODE_SUPERTYPE } from '../common/linqset-model';

const CHECKED = [NODE_SUPERTYPE.ACTION, NODE_SUPERTYPE.INFORMATION];

export const emptyNodes = (modelKey: string, nodes: LinqsetNode[], edges: LinqsetEdge[]): LinqsetNode[] => {
    // anything joined to it, even only a note, gives it a place in the model
    const connected = new Set(edges.flatMap(e => [e.sourceKey, e.targetKey]));
    return nodes.filter(n => n.modelKey === modelKey && CHECKED.includes(n.superType) && !(n.name || '').trim() && !connected.has(n._key));
};
